import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import { Provider, useSelector } from "react-redux";
import { IntlProvider } from "react-intl";
import intl from "./lang";

const IntlWrap = (props) => {
  const { message } = useSelector((state) => state.app);
  return (
    <IntlProvider locale="zh" messages={message || intl.messages}>
      {props.children}
    </IntlProvider>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <IntlWrap>
        <App />
      </IntlWrap>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
